import { NString } from 'types'

import type { IEntityResponse } from '../response'

export enum EventType {
  BREAST_LEFT = 'BreastFeedingLeft',
  BREAST_RIGHT = 'BreastFeedingRight',
  BOTTLE = 'BottleFeeding',
  SLEEP_DAY = 'SleepDay',
  SLEEP_NIGHT = 'SleepNight',
  POO = 'Poo',
  PEE = 'Pee',
}

interface IEvent {
  id?: number
  startTime: string
  eventTypeCode?: EventType
  endTime?: NString
  comment?: string
  volume?: string | number
}

type EventResponse = IEntityResponse<IEvent>

export type { IEvent, EventResponse }
